import { useRef, useState } from 'react'
import { SActionBtn, SLowcodeList, STableActions, SMessage, SAlert } from 'shj-components'
import { message, Upload, Button } from 'antd'
import {
  importSendPackConfig,
  getSendPackConfigList,
  deleteSendPackConfig,
  batchDeleteSendPackConfig,
} from '@/services/product'
import { getBranchComponyList } from '@/services/homeService'
import { fileDownload } from '@/utils/download.ts'
import { DownloadOutlined, UploadOutlined, ExclamationCircleOutlined } from '@ant-design/icons'
import UrlConfig from '@/api/UrlConfigs.ts'
import { config } from './config/index.tsx'
import styles from './index.module.less'

export default function QuoteContract() {
  const listRef = useRef()
  const [importLoading, setImportLoading] = useState(false)
  const [exportLoading, setExportLoading] = useState(false)

  const fetchList = async values => {
    try {
      const res: any = await getSendPackConfigList({
        data: {
          ...values?.query,
        },
        params: {
          pageId: values?.current,
          pageSize: 10,
        },
      })
      if (!res?.list) {
        message.error('查询列表失败')
        return
      }
      return {
        records: res?.list,
        total: res?.count,
      }
    } catch (err) {
      message.error('查询列表失败')
    }
  }

  const onDelete = async (record: any = {}) => {
    SMessage.delete({
      onOk: async () => {
        try {
          const res: any = await deleteSendPackConfig(record.id)
          if (res.errorCode === 0) {
            message.success('删除成功')
            ;(listRef as any)?.current?.reload()
          } else {
            message.error('删除失败')
          }
        } catch (err) {
          console.log(err)
        }
      },
      onCancel: () => {
        message.warning('取消删除')
      },
    })
  }

  const onImport = async (upload: any) => {
    setImportLoading(true)
    const { file, onSuccess } = upload
    const data = new FormData()
    data.append('file', file)
    try {
      const res: any = await importSendPackConfig(data)
      listRef.current && listRef.current.reload()
      onSuccess && onSuccess()
      if (res?.length) {
        let str = ''
        res.forEach((item, index) => {
          if (item?.errorMessages?.length) {
            str =
              str +
              ' ' +
              `第${item.lineNumber}行` +
              '、' +
              item?.errorMessages.join('、')?.slice(0, 100)
          }
        })
        str = str?.slice(0, 300)
        if (str !== '') {
          message.error(str)
        } else {
          message.success(res.message || '导入成功')
        }
      } else {
        message.success(res.message || '导入成功')
      }
      setImportLoading(false)
    } catch (err) {
      setImportLoading(false)
      console.log(err)
    }
  }

  const onExport = async () => {
    try {
      setExportLoading(true)
      await fileDownload(UrlConfig.PlusProductWeb.DownloadSendPackConfig)
      setExportLoading(false)
    } catch (err) {
      setExportLoading(false)
      console.log(err)
    }
  }

  const onMultipleDelete = ({ selectedRowKeys }) => {
    SMessage.delete({
      onOk: async () => {
        try {
          const res: any = await batchDeleteSendPackConfig(selectedRowKeys)
          if (res.errorCode === 0) {
            message.success('删除成功')
            ;(listRef as any)?.current?.reload()
          } else {
            message.error('删除失败')
          }
        } catch (err) {
          console.log(err)
        }
      },
      onCancel: () => {
        message.warning('取消删除')
      },
    })
  }

  const getStatusOptions = async () => {
    const res = await getBranchComponyList()
    return {
      companyOptions: res,
    }
  }

  // 右侧表格配置
  const extensions = {
    request: { fetchList, getStatusOptions },
    events: { onMultipleDelete },
    customRender: {
      actionRender(_, record: Record<string, any>) {
        return (
          <STableActions>
            <SActionBtn danger onClick={() => onDelete(record)}>
              删除
            </SActionBtn>
          </STableActions>
        )
      },
      importRender: () => {
        return (
          <Upload listType="text" customRequest={onImport} itemRender={() => null}>
            <Button
              type={'primary'}
              loading={importLoading}
              disabled={importLoading}
              icon={<UploadOutlined />}
            >
              批量导入
            </Button>
          </Upload>
        )
      },
      exportRender: () => {
        return (
          <Button
            icon={<DownloadOutlined />}
            onClick={onExport}
            disabled={exportLoading}
            loading={exportLoading}
            type="dashed"
          >
            下载导入模板
          </Button>
        )
      },
    },
  }

  return (
    <div className={styles.settlementQuotaConfig}>
      {/* 右侧数据表格 */}
      <div className={styles.rightTable}>
        <SAlert type="info">
          该配置主要用于组合产品SPU不同门店是否发包的配置。未在该位置配置发包为否的默认均要发包。单品、基础项默认均要发包。
        </SAlert>
        <SLowcodeList ref={listRef} searchMode="group" config={config} {...extensions} />
      </div>
    </div>
  )
}
